import useVideoContext from '../useVideoContext/useVideoContext';

export default function useIsRecording(): boolean {
  useVideoContext();
  return false;
}
